import { createRecipe } from './runtime.mjs';

const iconConfig = {"name":"icon","className":"ds-icon","variantMap":{"size":["sm","md","lg","xl"]}}

export const icon = /* @__PURE__ */ createRecipe(iconConfig)